<template>
  <RevButton :class="widthClasses" full-width="adaptive" :size :variant>
    <slot></slot>
  </RevButton>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { tw } from '@backmarket/utils/string/tw'
import { RevButton } from '@ds/components/Button'
import type { Sizes, Variants } from '@ds/components/Button/Button.constant'

type CmsButtonBaseProps = {
  width?: 'adaptive' | 'fixed' | 'full-width' | 'never'
  size?: Sizes
  variant?: Variants
}

const props = withDefaults(defineProps<CmsButtonBaseProps>(), {
  size: 'medium',
  variant: 'primary',
  width: 'fixed',
})

const widthClasses = computed(() => {
  switch (props.width) {
    case 'fixed':
      return tw`md:!w-[360px] w-full max-w-full`
    case 'full-width':
      return tw`!w-full`
    case 'never':
      return tw`!w-fit`
    case 'adaptive':
    default:
      return ''
  }
})
</script>
